@use 'styles/functions/rem' as *;

.cardHeader {
    align-items: center;
    border-bottom: rem(1px) solid var(--card-header-border-color);
    display: flex;
    justify-content: space-between;
    padding: var(--card-header-padding);
    width: 100%;
}

.title {
    color: var(--card-header-title-color);
    font-family: var(--card-header-title-font-family);
    font-size: var(--card-header-title-font-size);
    font-weight: var(--card-header-title-font-weight);
}

.action {
    align-items: center;
    display: flex;
    margin-left: rem(12px);
}
